<template>
  <!-- Markup + `.qty-stepper` styles come from the prototype stylesheet. -->
  <div class="qty-stepper">
    <button
      type="button"
      :aria-label="decLabel"
      :disabled="value <= min"
      @click.stop="step(-1)"
    >&minus;</button>
    <div class="val">{{ value }}</div>
    <button
      type="button"
      :aria-label="incLabel"
      :disabled="value >= max"
      @click.stop="step(1)"
    >+</button>
  </div>
</template>

<script>
export default {
  name: 'lp-qty-stepper',
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 99 },
    decLabel: { type: String, default: 'Decrease quantity' },
    incLabel: { type: String, default: 'Increase quantity' },
  },
  methods: {
    step(delta) {
      const next = Math.min(this.max, Math.max(this.min, this.value + delta))
      if (next !== this.value) this.$emit('input', next)
    },
  },
}
</script>

<style lang="scss">
.qty-stepper {
  display: flex;
  align-items: center;
  gap: 0;
  border: 0.5px solid var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--surface);
  overflow: hidden;
}
.qty-stepper button {
  width: 32px; height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: var(--fs-subhead);
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  transition: background 0.1s;
}
.qty-stepper button:hover:not(:disabled) { background: var(--bg); }
.qty-stepper button:disabled { color: var(--text-tertiary); cursor: not-allowed; }
.qty-stepper .val {
  min-width: 32px;
  text-align: center;
  font-size: var(--fs-body);
  font-weight: 500;
  border-left: 0.5px solid var(--border);
  border-right: 0.5px solid var(--border);
  padding: 0 8px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
